import { render } from "./inputRange.vue?vue&type=template&id=5cd12d93&ts=true"
import script from "./inputRange.vue?vue&type=script&lang=ts"
export * from "./inputRange.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__